<template>
  <div class="style">
    <h1>Style</h1>
    <section class="atoms-style">
      <div class="container">
        <div class="row">
          <div class="col-6 Cc">

            <p class="font-regular ">Lorem ipsum dolor sit amet. font-regular</p>
            <p class="font-medium">Lorem ipsum dolor sit amet. font-medium</p>
            <p class="font-semiBold">Lorem ipsum dolor sit amet. font-semiBold</p>
            <p class="font-extraBold">Lorem ipsum dolor sit amet. font-extraBold</p>

          </div>
          <div class="col-6">

            <h1>Lorem ipsum dolor sit amet.</h1>
            <h2>Lorem ipsum dolor sit amet.</h2>
            <h3>Lorem ipsum dolor sit amet.</h3>
            <h4>Lorem ipsum dolor sit amet.</h4>
            <h5>Lorem ipsum dolor sit amet.</h5>
          </div>
          <div class="col-8 my-5 ">
            <div class="row justify-content-between Cc">
              <div class="col-2">
                <div class="block-test box-shadow-06">
                  <p>06</p>
                </div>
              </div>
              <div class="col-2 align-self-center ">
                <div class="block-test box-shadow-04">
                  <p>04</p>
                </div>
              </div>
              <div class="col-2 align-self-center">
                <div class="block-test box-shadow-02">
                  <p>02</p>
                </div>
              </div>
              <div class="col-2 align-self-center">
                <div class="block-test box-shadow-01">
                  <p>01</p>
                </div>
              </div>
              <div class="col-2 align-self-center">
                <div class="block-test box-shadow-005">
                  <p>005</p>
                </div>
              </div>
            </div>
          </div> <!--box-shadow-->
          <div class="col-12">
            <div class="row">
              <div class="col-1">
                <div class="block-test bg-black ">
              <p>100</p>
            </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-90 text-black">
              <p>90</p>
            </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-80">
              <p>80</p>
            </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-70">
              <p>70</p>
            </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-60">
              <p>60</p>
            </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-50">
              <p>50</p>
            </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-40">
                  <p>40</p>
                </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-30">
                  <p class="text-black">30</p>
                </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-20">
                  <p>20</p>
                </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-10">
                  <p>10</p>
                </div>
              </div>
              <div class="col-1">
                <div class="block-test bg-black opacity-05 text-black">
                  <p>5</p>
                </div>
              </div>


            </div>

          </div> <!--color-->
          <div class="col-12">
            <div class="icon-group my-5">
              <h3>Icon</h3>
              <span class="icon icon-admin"></span>
              <span class="icon icon-alerty"></span>
              <span class="icon icon-arrow_down_big"></span>
              <span class="icon icon-arrow_down_small"></span>
              <span class="icon icon-arrow_left_big"></span>
              <span class="icon icon-close"></span>
              <span class="icon icon-faktury"></span>
              <span class="icon icon-zapisz"></span>
              <span class="icon icon-edit"></span>
              <span class="icon icon-email"></span>
            </div>
          </div><!--icon-->
          <div class="col-12">
            <b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="checkboxTestSelected"
                :options="checkboxTestOptions"
                name="flavour-1"
              ></b-form-checkbox-group>
            </b-form-group>

          </div><!--checkbox-->
          <div class="col-12">
            <b-form-group label="Radios using options">
              <b-form-radio-group
                id="radio-group-2"
                v-model="radioTestSelected"
                :options="radioTestOptions"
                name="radio-options"
              ></b-form-radio-group>
            </b-form-group>
          </div><!--radio-->
          <!--button-->
          <div class="col-12 ">
            <div d-flex justify-content-between>
              <b-button variant="outline-success" block
                        class="custom">Success
              </b-button>
              <b-button variant="success" block
                        class="custom">Success
              </b-button>
              <b-button variant="primary" block
                        class="custom">Primary
              </b-button>
              <b-button variant="danger" block
                        class="custom">Danger
              </b-button>
              <b-button variant="warning" block
                        class="custom">Warning
              </b-button>
              <b-button variant="secondary" block
                        class="custom">Secondary
              </b-button>
            </div>

            <div>
              <b-button variant="outline-success"
                        class="custom">Success
              </b-button>
              <b-button variant="success"
                        class="custom">Success
              </b-button>
              <b-link class="btn btn-success custom" href="#">asdasdasdad</b-link>
              <b-button variant="primary"
                        class="custom">Primary
              </b-button>
              <b-button variant="danger"
                        class="custom">Danger
              </b-button>

              <b-link variant="danger"
                      class="custom"
                      href="#">Danger
              </b-link>

              <b-button variant="warning"
                        class="custom">Warning
              </b-button>
              <b-button variant="secondary"
                        class="custom">Secondary
              </b-button>

            </div>
            <br>
            <b-button variant="secondary" block
                      size="lg"
                      class="custom">Secondary
            </b-button>
            <!---->

          </div>
          <!--end button-->

        </div>
      </div>

    </section>
    <section class="molecules-style"></section>
    <section class=" mt-5">
      <div class="container">
        <!--Element-->
        <div class="row">

          <!--link-->
          <div class="col-12">
            <div class="dark-wrap position-relative">
              <b-link class="btn-link dark-link custom " href="#">

                Link dark
              </b-link>
              <b-link class="btn-link dark-link small custom" href="#">

                Link dark
              </b-link>
            </div>
            <b-link class="btn-link  small custom" href="#">

              Link light
            </b-link>

            <div class="close mobile ">
              <span class="icon icon-close "></span>
            </div>
            <div class="sidebar-menu mobile">
              <span class="icon icon-menu "></span>
            </div>
          </div>
          <!--end-link-->
          <!--input-->
          <div class="col-12">
            <b-form-input v-model="text0" placeholder="input error" :state="false"
                          class="custom mb-3"></b-form-input>
            <b-form-input v-model="text0" placeholder="input" class="custom mb-3"></b-form-input>
            <div class="input-group mb-3 custom search">
              <div class="input-group-prepend">
                <a href="#">
                  <span class="input-group-text icon-search icon"></span>
                </a>

              </div>
              <input type="text"
                     class="form-control"
                     placeholder="search"
                     aria-label="Username"
                     aria-describedby="basic-addon1">
            </div>
            <div class="input-group mb-3 custom prepend-select">
              <div class="input-group-prepend ">
                <treeselect v-model="value"
                            :multiple="false"
                            :options="optionsTreeSelect"
                            placeholder="PLN"
                            class="custom"
                />

              </div>
              <b-form-input v-model="text0" placeholder="input" class="custom mb-3"></b-form-input>

            </div>


            <treeselect v-model="value"
                        :multiple="false"
                        placeholder="SELECT"
                        :options="optionsTreeSelect"
                        class="custom"
            />

          </div>
          <!--end input-->
          <!--card-->
          <div class="col-12">
            <div class="card-group-presets">

              <b-card header="Default" class="custom">
                <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</b-card-text>
              </b-card>
              <b-card bg-variant="success" header="Success" class="custom">
                <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</b-card-text>
              </b-card>
              <b-card bg-variant="primary" header="Primary" class="custom">
                <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</b-card-text>
              </b-card>
              <b-card bg-variant="info" header="Info" class="custom">
                <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</b-card-text>
              </b-card>
              <b-card bg-variant="secondary" header="Secondary" class="custom">
                <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</b-card-text>
              </b-card>
            </div>
          </div>
          <!--end card-->
          <!--icon-->
          <div class="col-12">
            <div class="icon-group mb-4">
              <h3>Icon</h3>
              <span class="icon icon-close icon-data"></span>
              <span class="icon icon-data"></span>
              <span class="icon icon-depozyt_usun"></span>
              <span class="icon icon-dezaktywuj"></span>
              <span class="icon icon-dodaj_bold"></span>
              <span class="icon icon-druk"></span>
              <span class="icon icon-dul"></span>
              <span class="icon icon-edit"></span>
            </div>
          </div>
          <!--end icon-->
          <!--breadcrumb-->
          <div class="col-12">
            <nav aria-label="breadcrumb ">
              <ol class="breadcrumb">
                <li class="breadcrumb-item ">
                  <a href="#">Kontrahenci</a>
                </li>
                <li class="breadcrumb-item ">
                  <a href="#">Lista kontrahentów</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Noori El Mansur
                </li>
              </ol>
            </nav>
          </div>
          <!--end breadcrumb-->
          <div class="col-12">
            <b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selected"
                :options="options"
                name="flavour-1"
              ></b-form-checkbox-group>
            </b-form-group>

          </div>
          <!--end checkbox-->
          <!--radio-->
          <div class="col-12">
            <b-form-group label="Radios using options">
              <b-form-radio-group
                id="radio-group-1"
                v-model="selected"
                :options="options"
                name="radio-options"
              ></b-form-radio-group>
            </b-form-group>
          </div>
          <!--end radio-->
          <div class="col-12">
            <b-form-select v-model="selected" :options="options" class=" mb-3"></b-form-select>

            <!--                            <a-tree-select-->
            <!--                                    style="width: 300px"-->
            <!--                                    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"-->
            <!--                                    :treeData="treeData"-->
            <!--                                    placeholder='Please select'-->
            <!--                                    treeDefaultExpandAll-->
            <!--                                    v-model="value"-->
            <!--                            >-->
            <!--treeselect ne podklyu4il js-->

            <div class="input-group mb-3 input-select custom">
              <div class="input-group-prepend">
                <button class="btn btn-outline-secondary dropdown-toggle custom"
                        type="button" data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">PLN
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" href="#">1</a>
                  <a class="dropdown-item" href="#">2</a>
                  <a class="dropdown-item" href="#">3</a>
                  <a class="dropdown-item" href="#">4</a>
                </div>
              </div>
              <input type="text" class="form-control"
                     aria-label="Text input with dropdown button">
            </div>
            <span style="color: #08c" slot="title" slot-scope="{key, value}" v-if="key='0-0-1'">
    Child Node1 {{value}}
  </span>
            <!--                            </a-tree-select>-->
          </div>
          <!--big table-->
          <div class="col-12">
            <b-table
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            ></b-table>
          </div>
          <!--big table-->

        </div>
        <!-- end Element-->

      </div>
    </section>
  </div>
</template>

<script>
  // import the component
  import Treeselect from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'style',
  components: { Treeselect },
  data () {
    return {
      optionsTreeSelect: [{
        id: 'a',
        label: 'a'
        /* children: [{
                        id: 'aa',
                        label: 'aa',
                    }, {
                        id: 'ab',
                        label: 'ab',
                    }], */
      }, {
        id: 'b',
        label: 'b'
      }, {
        id: 'c',
        label: 'c'
      }],
      checkboxTestSelected: [], // Must be an array reference!
      checkboxTestOptions: [
        { text: 'first', value: 'first' },
        { text: 'two', value: 'two' },
        { text: 'tree', value: 'tree' },
      ],
      radioTestSelected: [], // Must be an array reference!
      radioTestOptions: [
        { text: 'first', value: 'first' },
        { text: 'two', value: 'two' },
        { text: 'tree', value: 'tree' },
      ]
    }
  },
  methods: {}
}
</script>
